import { render, staticRenderFns } from "./headers-public.vue?vue&type=template&id=19eae2b0&scoped=true&lang=pug&"
import script from "./headers-public.vue?vue&type=script&lang=js&"
export * from "./headers-public.vue?vue&type=script&lang=js&"
import style0 from "./headers-public.vue?vue&type=style&index=0&id=19eae2b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19eae2b0",
  null
  
)

export default component.exports